module.exports = __webpack_public_path__ + "favicon-16x16.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=[name].[ext]!./src/favicon-16x16.png
// module id = 143
// module chunks = 0